import ButtonAcceptToSign from './ButtonAcceptToSign';

export default ButtonAcceptToSign;
